import useProfile from '../../../../hooks/providers/useProfile';
import Button from '../../../form/buttons/Button/Button';

const OnboardingLastStepCloseModalButton = () => {
  const {setIsOnboardingModalOpen: setIsOpen} = useProfile();

  return (
    <Button
      onClick={() => setIsOpen(false)}
      variant="contained"
      sx={{
        minWidth: 250,
        display: 'block',
        margin: '0 auto',
        fontSize: 13,
        mt: 3,
        mb: 1
      }}
      color="primary"
    >
      Terminer
    </Button>
  );
};

export default OnboardingLastStepCloseModalButton;
